export default "__VITE_ASSET__DuayTeS$__"